// This file was automatically generated from appshared.dialog.confirmPassportRegistration.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.confirmPassportRegistration');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.confirmPassportRegistration.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="confirm-passport-registration-content" class="el8PromptDialogContainer">', (opt_data.isFromLetter) ? '<h4 class="el8ConfirmationHeader">Your letter has been delivered</h4><p class="el8Spacer">' + soy.$$escapeHtml(opt_data.patient.firstName) + ' ' + soy.$$escapeHtml(opt_data.patient.lastName) + ' must log into Passport to view your letter. An invitation email to Elation Passport has been sent to <span class="el8Bold">' + soy.$$escapeHtml(opt_data.patient.email) + '</span>.</p>' : '<h4 class="el8ConfirmationHeader">Passport invitation has been sent</h4><p class="el8Spacer">An invitation email for Elation Passport has been sent to <span class="el8Bold">' + soy.$$escapeHtml(opt_data.patient.email) + '</span>.</p>', '<p class="el8Spacer">For security, a text message including an invitation code will be sent to the patient\'s cell phone to complete the sign-up process.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.confirmPassportRegistration.passportPhoneNum = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.passportPhone == 'phone1') ? soy.$$escapeHtml(opt_data.phone1) : (opt_data.passportPhone == 'phone2') ? soy.$$escapeHtml(opt_data.phone2) : '(unknown)');
  if (!opt_sb) return output.toString();
};
